module.exports = __webpack_public_path__ + "img/lead-HL.47a73a72.png";